// src/components/LoadingButton.jsx

import React, { useState, useEffect } from 'react';

export const loadingMessages = [
  '🔍 Fetching related topics...',
  '⚙️ Compiling content...',
  '🔗 Fetching links and resources...',
  '🚀 Putting things together...',
  '🚤 Almost there...',
  '🐱 Experiencing increased traffic, hold on...',
];

export const LoadingButton = React.memo(() => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prevIndex) => (prevIndex + 1) % loadingMessages.length);
    }, 6000); // change message every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '8px 16px',
        backgroundColor: '#1e1e1e',
        color: '#fff',
        borderRadius: '8px',
        fontSize: '13px',
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 500,
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div
        style={{
          width: '6px',
          height: '6px',
          backgroundColor: '#ff4757',
          borderRadius: '50%',
          animation: 'pulse 1s infinite',
        }}
      />
      {loadingMessages[messageIndex]}
    </div>
  );
});